import { t } from '@lingui/core/macro';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { SearchStringFilter } from './SearchStringFilter';
import { useGetUsers } from './useGetUsers/useGetUsers';
export const projectOwnerFilterLabel = () => t({ message: 'Project owner', comment: 'Insights filter: Project owner' });
export const ProjectOwnerFilter = withFilterErrorBoundary(() => {
    const { data, error, loading } = useGetUsers();
    const disabled = Boolean(loading || error);
    return (<SearchStringFilter name="metadataProjectProjectOwner" items={data} label={projectOwnerFilterLabel()} loading={disabled}/>);
});
